module.exports = "../dist/img/img_2-32.4fa9.jpg";